module.exports = __webpack_public_path__ + "img/loan.77002ce9.svg";